import { compose } from 'redux';
import { connect } from 'react-redux';
import withAuth from '../../common/WithAuth';
import CartViewer, { Header } from '../../pages/CartViewer/CartViewer';
import {
    getListProductRequested,
    clearListProduct,
    getListHistoryOrderRequested,
    clearListHistoryOrder,
    deleteProductRequested,
    clearDeleteProduct,
    changeQuantityProductRequested,
    clearChangeQuantity,
    getCountProductRequested,
} from '../../actions/CartViewer';

const mapStateToProps = (state) => ({
    locale: state.locale.lang.current,
    isLoading: state.cartViewer.getListProduct.isFetching
                || state.cartViewer.getListHistoryOrder.isFetching
                || state.cartViewer.deleteProduct.isFetching
                || state.cartViewer.changeQuantityProduct.isFetching
                || state.adminSettingCustom.getCustomText.isFetching,
    listProductOrder: state.cartViewer.getListProduct.data,
    listHistory: state.cartViewer.getListHistoryOrder.data,
    successDeleteProduct: state.cartViewer.deleteProduct.isSuccess,
    successChangeQuantity: state.cartViewer.changeQuantityProduct.data,
    errorQuantityProduct: state.cartViewer.changeQuantityProduct.errors,
    eventInfo: state.registration.registrationViewer.data,
    customText: state.adminSettingCustom.getCustomText.data?.content,
    customColor: state.registration.registrationViewer.data?.settings_colors_viewer,
    customPersonInfo: state.adminSettingCustom.getCustomText.data?.content_personal_info,
});

const mapDispatchToProps = (dispatch) => ({
    getListProductCart: (param) => {
        dispatch(getListProductRequested(param));
    },
    clearProduct: () => {
        dispatch(clearListProduct());
    },
    getListHistoryOrder: (param) => {
        dispatch(getListHistoryOrderRequested(param));
    },
    clearListHistoryOrder: () => {
        dispatch(clearListHistoryOrder());
    },
    deleteProduct: (param) => {
        dispatch(deleteProductRequested(param));
    },
    clearDeleteProduct: () => {
        dispatch(clearDeleteProduct());
    },
    changeQuantityProduct: (param) => {
        dispatch(changeQuantityProductRequested(param));
    },
    clearChangeQuantity: () => {
        dispatch(clearChangeQuantity());
    },
    getCount: () => {
        dispatch(getCountProductRequested());
    },
});

export const CartViewerHeader = connect(mapStateToProps, mapDispatchToProps)(Header);

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(CartViewer);
